import { SERVER_URI } from '../Constant/server';
import { apiGet, apiPost, apiPut } from '../utils/axios';

const ADD_SALES_TAB = SERVER_URI + '/sales-tab';
const BIND_SALES_TAB = SERVER_URI + '/get-sales-tab';
const CHANGE_STATUS = SERVER_URI + '/sales-tab-status/';
const UPDATE_SALES_TAB = SERVER_URI + '/sales-tab/';
const GET_DISPLAYORDER = SERVER_URI + '/get-display-order';


export default {
    Create_Sales_Tab: async function (paylaod) {
        return apiPost(ADD_SALES_TAB, paylaod)
    },
    Sales_Tab_List: async function (paylaod) {
        return apiPost(BIND_SALES_TAB, paylaod)
    },
    UpdateStatus: async function (id) {
        return apiGet(CHANGE_STATUS + id)
    },
    updateSalesTab: async function (id, paylaod) {
        return apiPut(UPDATE_SALES_TAB + id, paylaod)
    },
    getDisplayOrder:async function(){
        return apiGet(GET_DISPLAYORDER)
    }

};